'use strict'

/**
 * Pop up 3M
 */

import selectorPanel from 'Modules/selectorPanel'
import profileCookie from 'Modules/profileCookie'
import tooltips from 'Modules/tooltips'
import url from 'Modules/url'
import modal from 'Modules/modal'
import validationForm from 'Modules/validationForm'

const J_BUTTON_SUBMIT = '.j_submit3MPlus'
const J_BORDER_SELECTED = '.j_borderSelected'
const J_LIST_CATEGORY = '.j_listCategory'
const J_GENDER_DATA = 'category'
const C_ACTIVE_SELECTOR = '.active'
const J_URL = '.j_url'
const J_TYPE_MODULE_DATA = 'type'
const J_FORM_3MPLUS = '.j_form3MPlus'
const J_PROFILE_GENDER_DATA = 'profilegender'
const J_PANEL_ITEM = '.j_panelItem'
const C_BUTTON_STYLE_OFF = 'goBtn-disabled'
const C_BUTTON_STYLE_ON = 'goBtn'
const C_CLASS_PINK_BUTTON = 'btn-empty'
const J_TOOLTIP_TRIGGER = '.j_3mPlusToolTipTrigger'
const J_FAMILY_DATA = 'family'
const J_TRIGGER_DATA = 'count'
const J_MUST_LOAD_DATA = 'mustload'
const J_LINKFEMME_DATA = 'linkfemme'
const J_LINKHOMME_DATA = 'linkhomme'
const J_LINKGARCON_DATA = 'linkgarcon'
const J_LINKFILLE_DATA = 'linkfille'
const J_LINK_DATA = 'link'
const J_ACCORDION_3M = '.j_accordion3M'
const setEnableEvent = switch3MPlus
const C_ARROW = ' <b class="caret"></b>'
const C_ARROW2ROTATE =
    '<b class="chevron hidden-xs"></b><span class="visible-xs chevronrotate" style="transform: rotate(45deg); border-color: rgb(0, 0, 0);"></span>'
const setDisableEvent = setOnClickToolTip
/*
 * Fonction qui va lancer tous le process du 3m+
 */
function process() {
    $(document).ready(function () {
        $('.modaltest3m10')
            .parents('.mm-page')
            .siblings('.modal-backdrop')
            .addClass('zindex')
    })

    /* Lazyload img */
    $('.bloc3M .j_listCategory').click(function () {
        const imgArray = document.querySelectorAll('.lazyload-3m')

        for (let i = 0; i < imgArray.length; i++) {
            const img = imgArray[i]

            if (img.getAttribute('data-src')) {
                img.src = img.getAttribute('data-src')
                img.removeAttribute('data-src')
            }
        }
    })

    $('.jfinalstep').mouseup(function () {
        profileCookie.init()
        const cookie = profileCookie.getCurrentProfile()
        const genre = cookie.gender
        window.location.href =
            url.deleteParams('np', window.location.href) + '?cg=' + genre
    })
    $('#modaltest3m10 .j_listCategory').on('click', function () {
        selectorPanel.showPanel(this)
        $('.j_genreSelector').hide()
        $('.j_panelItems').fadeIn()
    })
    $('#modaltest3m10 .j_tailleshaut .checkbox-t3m').on('click', function () {
        $('.j_tailleshaut').hide()
        $('.j_taillesbas').fadeIn()
    })
    $('#modaltest3m10 .j_taillesbas .checkbox-t3m').on('click', function () {
        $('.j_taillesbas').hide()
        $('.j_tailleschaussure').fadeIn()
    })
    $('#modaltest3m10 .j_taillesage .checkbox-t3m').on('click', function () {
        $('.j_taillesage').hide()
        $('.j_tailleschaussure').fadeIn()
    })
    $('#modaltest3m10 .j_tailleschaussure .checkbox-t3m').on(
        'click',
        function () {
            $('.j_tailleschaussure').hide()
            $('.j_taillesorigin').hide()
            $('.blocmail3m').fadeIn()
        }
    )

    // Enregistrement du mail du client dans la pop-up du 3M

    const J_VALIDATION_BUTTON_3M = '.btnvalidemail3m'
    const J_FORM_NEWSLETTER_3M = '.j_form_newsletter_3m'
    const J_EMAIL_NAME = 'j_email'
    const J_ACTION_DATA = 'action'
    const C_GREEN = 'green'
    const C_RED = 'red'
    const C_BLACK = 'black'
    /*
     * Set l'event click sur le bouton de validation de la newsletter
     *
     */

    $(J_FORM_NEWSLETTER_3M).on('submit', function () {
        const form = $(this)

        $(J_VALIDATION_BUTTON_3M).attr('disabled', true)
        validationForm.process(
            function (content) {
                // Callback de réussite
                $("input[name='" + J_EMAIL_NAME + "']").val(content.Message)
                manageStyleForNewsletterError(content)
                eraseColorForNewsLetter()
                profileCookie.saveCookie()

                const cookie = profileCookie.getCurrentProfile()
                const genre = cookie.gender

                if ($(J_VALIDATION_BUTTON_3M).hasClass('j_test_modal3M')) {
                    $('.j_message_capital').show()
                    $('.email3m').css('margin-top', '30px')
                    $(J_VALIDATION_BUTTON_3M).hide()
                    $('.j_close_modal3M').show()
                } else {
                    window.location.href =
                        url.deleteParams('np', window.location.href) +
                        '?cg=' +
                        genre
                }
            },
            function (content) {
                // Callback si échec. C'est la même que la réussite : l'erreur est mis dans le champ email
                $("input[name='" + J_EMAIL_NAME + "']").val(content.Message)
                manageStyleForNewsletterError(content)
                eraseColorForNewsLetter()
                $(J_VALIDATION_BUTTON_3M).attr('disabled', false)
            },
            function (msg) {
                // Callback exécuter si l'email n'a pas le bon format
                const content = {
                    // Dans le cas du mail incorrect, on est pas passé dans l'ajax, il faut donc ajouter les éléments permettant de gérer les erreurs manuellement
                    Error: true,
                    CssClass: C_RED,
                    Message: msg
                }
                $("input[name='" + J_EMAIL_NAME + "']").val(content.Message)
                manageStyleForNewsletterError(content)
                eraseColorForNewsLetter()
                $(J_VALIDATION_BUTTON_3M).attr('disabled', false)
            },
            $(form).data(J_ACTION_DATA), // Le controller à appeler
            form
        )

        return false
    })

    /*
     * Va gérer les styles CSS à appliquer au champ newsletter selon le message
     */
    function manageStyleForNewsletterError(content) {
        if (content.CssClass == C_GREEN) {
            $("input[name='" + J_EMAIL_NAME + "']").addClass(C_GREEN)
        }
        if (content.CssClass == C_BLACK) {
            $("input[name='" + J_EMAIL_NAME + "']").addClass(C_BLACK)
        }
        if (content.CssClass == C_RED) {
            $("input[name='" + J_EMAIL_NAME + "']").addClass(C_RED)
        }
    }

    /*
     * Va effacer les couleurs des champs emails quand on tape dedans
     */
    function eraseColorForNewsLetter() {
        $("input[name='" + J_EMAIL_NAME + "']").on('focus', function (item) {
            $(item.currentTarget).removeClass(C_GREEN)
            $(item.currentTarget).removeClass(C_BLACK)
            $(item.currentTarget).removeClass(C_RED)
        })
    }

    $('.j_btn_intro').on('click', function () {
        $('.j_3m_intro').hide()
        $('.j_panelSelector').fadeIn()
    })
    $('.j_return_step_1').on('click', function () {
        $('.j_panelItems').hide()
        $('.j_genreSelector').fadeIn()
    })
    $('.j_return_step_2').on('click', function () {
        $('.j_taillesbas').hide()
        $('.j_tailleshaut').fadeIn()
    })
    $('.j_return_step_3').on('click', function () {
        $('.j_tailleschaussure').hide()
        $('.j_taillesbas').fadeIn()
    })
    $(
        '#modaltest3m10 ul.multiselect-tailles3m li:first-child > label > span'
    ).each(function () {
        if ($(this).text() === 'Prématuré') {
            $(this).parents().addClass('prehaut')
        }
    })

    $('.j_show_profil3m').bind('click', function () {
        if ($('.j-accordeon3M').html() == '') {
            const gender = $('.j-accordeon3M').data('genre')
            const urlAccordeon =
                window.location.origin + '/_3MPlus/Accordeon/?gender=' + gender
            modal.miseAjourParClassCss(
                'j-accordeon3M',
                urlAccordeon,
                CallbackAccordeon
            )
        } else {
            // on appelle la callback sans le chargement ajax car c'est déjà chargé
            $(J_ACCORDION_3M).addClass('open')
            $('.bandeau-3M').css('background-color', '#fff4f6')
            $('.bloc-config-taille > div').fadeIn()
        }
    })

    function CallbackAccordeon() {
        selectorPanel.setEvents(checkButtonForEachForm)
        checkButtonForEachForm()

        setOnClickTaille()

        $(J_ACCORDION_3M).addClass('open')
        $('.bandeau-3M').css('background-color', '#fff4f6')
        $('.bloc-config-taille > div').fadeIn()

        $('.j_tailles3m').on('click', function () {
            const id = $(this).attr('id')
            if ($('.multiselect-container').is(':visible')) {
                $('.j_tailles3m').removeClass('font-semi-sans')
                $('.multiselect-container').slideUp()
                $('.chevronrotate').animate(
                    { deg: -45 },
                    {
                        duration: 400,
                        step: function (now) {
                            $(this).css({ transform: 'rotate(' + now + 'deg)' })
                        }
                    }
                )
                if (!$('[data-label=' + id + ']').is(':visible')) {
                    $(this).addClass('font-semi-sans')
                    $('[data-label=' + id + ']').slideDown('slow')
                    $('#' + id + ' span').animate(
                        { deg: 45 },
                        {
                            duration: 400,
                            step: function (now) {
                                $(this).css({
                                    transform: 'rotate(' + now + 'deg)'
                                })
                            }
                        }
                    )
                }
            } else {
                $(this).addClass('font-semi-sans')
                $('[data-label=' + id + ']').slideDown('slow')
                $('#' + id + ' span').animate(
                    { deg: 45 },
                    {
                        duration: 400,
                        step: function (now) {
                            $(this).css({ transform: 'rotate(' + now + 'deg)' })
                        }
                    }
                )
            }
        })

        $('.jbtnpress').mousedown(function () {
            const idrange =
                '#' +
                $(this).siblings('.range-slider').find('.range').attr('id')
            const iddatalist =
                '#' +
                $(this).siblings('.range-slider').find('datalist').attr('id')
            const opt = $(
                iddatalist + ' option[value="' + $(idrange).val() + '"]'
            )
            const reg = /[-;]+/g
            const tableau = iddatalist.split(reg)
            const idDivContainerMulitselect =
                '.j_' +
                tableau[2].toUpperCase() +
                '_' +
                tableau[1].toUpperCase()
            $(idDivContainerMulitselect)
                .find('ul.multiselect-tailles3m')
                .each(function (index, item) {
                    const option = $($(item).find('.checkbox-t3m'))
                    option.each(function () {
                        if ($(this).val() == opt.attr('id')) {
                            $(this).trigger('click')
                        }
                    })
                })
        })

        $('.j_accordion_3M p.h3').on('click', function () {
            if ($(J_ACCORDION_3M).hasClass('open')) {
                $('.j_accordion_3M > div').hide()
                $(J_ACCORDION_3M).removeClass('open')
            } else {
                $(J_ACCORDION_3M).addClass('open')
                $(' .j_accordion_3M > div').fadeIn()
            }
        })
    }

    $(document).bind('click', function (e) {
        const $clicked = $(e.target)
        if (!$clicked.parents().hasClass('zonetailles3m'))
            $('.zonetailles3m .multiselect-container').slideUp()
        if (
            !$clicked.parents().hasClass('bandeau-3M') &&
            !$clicked.hasClass('j_show_profil3m')
        ) {
            $('.bandeau-3M').css('background-color', '#fff')
            $('.bloc-config-taille').removeClass('open')
            $('.bloc-config-taille > div').hide('slow')
        }
    })

    setToolTip()
    setOnClickTaille()
}

function processLight() {
    // Enregistrement du mail du client dans la pop-up du 3M

    const J_VALIDATION_BUTTON_3M = '.btnvalidemail3m'
    const J_FORM_NEWSLETTER_3M = '.j_formr_3m_light'
    const J_EMAIL_NAME = 'j_email'
    const J_ACTION_DATA = 'action'
    const C_GREEN = 'green'
    const C_RED = 'red'
    const C_BLACK = 'black'
    /*
     * Set l'event click sur le bouton de validation de la newsletter
     *
     */

    $('.jfinalstep').mouseup(function () {
        $('#modal3mlight').modal('hide')
    })

    $(J_FORM_NEWSLETTER_3M).on('submit', function () {
        const form = $(this)

        $(J_VALIDATION_BUTTON_3M).attr('disabled', true)
        validationForm.process(
            function (content) {
                // Callback de réussite
                $("input[name='" + J_EMAIL_NAME + "']").val(content.Message)
                manageStyleForNewsletterError(content)
                eraseColorForNewsLetter()
                //$('#modal3mlight').modal('hide')
                $('.j_message_capital').show()
            },
            function (content) {
                // Callback si échec. C'est la même que la réussite : l'erreur est mis dans le champ email
                $("input[name='" + J_EMAIL_NAME + "']").val(content.Message)
                manageStyleForNewsletterError(content)
                eraseColorForNewsLetter()
                $(J_VALIDATION_BUTTON_3M).attr('disabled', false)
            },
            function (msg) {
                // Callback exécuter si l'email n'a pas le bon format
                const content = {
                    // Dans le cas du mail incorrect, on est pas passé dans l'ajax, il faut donc ajouter les éléments permettant de gérer les erreurs manuellement
                    Error: true,
                    CssClass: C_RED,
                    Message: msg
                }
                $("input[name='" + J_EMAIL_NAME + "']").val(content.Message)
                manageStyleForNewsletterError(content)
                eraseColorForNewsLetter()
                $(J_VALIDATION_BUTTON_3M).attr('disabled', false)
            },
            $(form).data(J_ACTION_DATA), // Le controller à appeler
            form
        )

        return false
    })

    /*
     * Va gérer les styles CSS à appliquer au champ newsletter selon le message
     */
    function manageStyleForNewsletterError(content) {
        if (content.CssClass == C_GREEN) {
            $("input[name='" + J_EMAIL_NAME + "']").addClass(C_GREEN)
        }
        if (content.CssClass == C_BLACK) {
            $("input[name='" + J_EMAIL_NAME + "']").addClass(C_BLACK)
        }
        if (content.CssClass == C_RED) {
            $("input[name='" + J_EMAIL_NAME + "']").addClass(C_RED)
        }
    }

    /*
     * Va effacer les couleurs des champs emails quand on tape dedans
     */
    function eraseColorForNewsLetter() {
        $("input[name='" + J_EMAIL_NAME + "']").on('focus', function (item) {
            $(item.currentTarget).removeClass(C_GREEN)
            $(item.currentTarget).removeClass(C_BLACK)
            $(item.currentTarget).removeClass(C_RED)
        })
    }

    $('.j_btn_intro').on('click', function () {
        $('.j_3m_intro').hide()
        $('.j_panelSelector').fadeIn()
    })
    $('.j_return_step_1').on('click', function () {
        $('.j_panelItems').hide()
        $('.j_genreSelector').fadeIn()
    })
    $('.j_return_step_2').on('click', function () {
        $('.j_taillesbas').hide()
        $('.j_tailleshaut').fadeIn()
    })
    $('.j_return_step_3').on('click', function () {
        $('.j_tailleschaussure').hide()
        $('.j_taillesbas').fadeIn()
    })
    $(
        '#modaltest3m10 ul.multiselect-tailles3m li:first-child > label > span'
    ).each(function () {
        if ($(this).text() === 'Prématuré') {
            $(this).parents().addClass('prehaut')
        }
    })

    $('.j_show_profil3m').bind('click', function () {
        if ($('.j-accordeon3M').html() == '') {
            const gender = $('.j-accordeon3M').data('genre')
            const urlAccordeon =
                window.location.origin + '/_3MPlus/Accordeon/?gender=' + gender
            modal.miseAjourParClassCss(
                'j-accordeon3M',
                urlAccordeon,
                CallbackAccordeon
            )
        } else {
            // on appelle la callback sans le chargement ajax car c'est déjà chargé
            $(J_ACCORDION_3M).addClass('open')
            $('.bandeau-3M').css('background-color', '#fff4f6')
            $('.bloc-config-taille > div').fadeIn()
        }
    })

    function CallbackAccordeon() {
        selectorPanel.setEvents(checkButtonForEachForm)
        checkButtonForEachForm()

        setOnClickTaille()

        $(J_ACCORDION_3M).addClass('open')
        $('.bandeau-3M').css('background-color', '#fff4f6')
        $('.bloc-config-taille > div').fadeIn()

        $('.j_tailles3m').on('click', function () {
            const id = $(this).attr('id')
            if ($('.multiselect-container').is(':visible')) {
                $('.j_tailles3m').removeClass('font-semi-sans')
                $('.multiselect-container').slideUp()
                $('.chevronrotate').animate(
                    { deg: -45 },
                    {
                        duration: 400,
                        step: function (now) {
                            $(this).css({ transform: 'rotate(' + now + 'deg)' })
                        }
                    }
                )
                if (!$('[data-label=' + id + ']').is(':visible')) {
                    $(this).addClass('font-semi-sans')
                    $('[data-label=' + id + ']').slideDown('slow')
                    $('#' + id + ' span').animate(
                        { deg: 45 },
                        {
                            duration: 400,
                            step: function (now) {
                                $(this).css({
                                    transform: 'rotate(' + now + 'deg)'
                                })
                            }
                        }
                    )
                }
            } else {
                $(this).addClass('font-semi-sans')
                $('[data-label=' + id + ']').slideDown('slow')
                $('#' + id + ' span').animate(
                    { deg: 45 },
                    {
                        duration: 400,
                        step: function (now) {
                            $(this).css({ transform: 'rotate(' + now + 'deg)' })
                        }
                    }
                )
            }
        })

        $('.jbtnpress').mousedown(function () {
            const idrange =
                '#' +
                $(this).siblings('.range-slider').find('.range').attr('id')
            const iddatalist =
                '#' +
                $(this).siblings('.range-slider').find('datalist').attr('id')
            const opt = $(
                iddatalist + ' option[value="' + $(idrange).val() + '"]'
            )
            const reg = /[-;]+/g
            const tableau = iddatalist.split(reg)
            const idDivContainerMulitselect =
                '.j_' +
                tableau[2].toUpperCase() +
                '_' +
                tableau[1].toUpperCase()
            $(idDivContainerMulitselect)
                .find('ul.multiselect-tailles3m')
                .each(function (index, item) {
                    const option = $($(item).find('.checkbox-t3m'))
                    option.each(function () {
                        if ($(this).val() == opt.attr('id')) {
                            $(this).trigger('click')
                        }
                    })
                })
        })

        $('.j_accordion_3M p.h3').on('click', function () {
            if ($(J_ACCORDION_3M).hasClass('open')) {
                $('.j_accordion_3M > div').hide()
                $(J_ACCORDION_3M).removeClass('open')
            } else {
                $(J_ACCORDION_3M).addClass('open')
                $(' .j_accordion_3M > div').fadeIn()
            }
        })
    }

    $(document).bind('click', function (e) {
        const $clicked = $(e.target)
        if (!$clicked.parents().hasClass('zonetailles3m'))
            $('.zonetailles3m .multiselect-container').slideUp()
        if (
            !$clicked.parents().hasClass('bandeau-3M') &&
            !$clicked.hasClass('j_show_profil3m')
        ) {
            $('.bandeau-3M').css('background-color', '#fff')
            $('.bloc-config-taille').removeClass('open')
            $('.bloc-config-taille > div').hide('slow')
        }
    })

    setToolTip()
    setOnClickTaille()
}

/*
 * Gestion de l'événement onClick sur les bouton j_submit3MPlus (GO)
 * Actuellement, cela va rediriger vers la page du genre auquel correspond ce bouton
 */
function setOnClickEvent($element) {
    $element.off('click', setDisableEvent)
    $element.on('click', setEnableEvent)
}

function setOnClickTaille() {
    $('.j_taillesorigin .checkbox-t3m').on('click', function (event) {
        const parentUL = $(this).parents('ul.multiselect-tailles3m')
        const labelTaille = parentUL.siblings('.btn-multiselect')
        const options = parentUL.find('.checkbox-t3m:checked')
        if (options.length === 0) {
            // Si on a rien de sélectionné
            labelTaille.html($t('TAILLE') + C_ARROW)
        } else if (options.length > 0 && options.length < 3) {
            // Si on a moins de 3 options sélectionnées
            let selected = ''
            options.each(function () {
                selected += $(this).data('label') + ', '
            })
            labelTaille.html(selected.substr(0, selected.length - 2) + C_ARROW)
        } else {
            // Si on a plus de 3 options sélectionnées
            labelTaille.html(options.length + ' ' + $t('TAILLES') + C_ARROW)
        }

        $(event.currentTarget).removeClass(C_CLASS_PINK_BUTTON)
        tooltips.hideToolTip(event.currentTarget)

        getDataAndSaveProfileV2(this, parentUL)
    })
    $('.lestailles .checkbox-t3m').on('click', function (event) {
        const parentUL = $(this).parents('ul.multiselect-tailles3m')
        const labelTaille = parentUL.siblings('.btn-multiselect')
        const options = parentUL.find('.checkbox-t3m:checked')
        if (options.length === 0) {
            // Si on a rien de sélectionné
            if ($(this).parents('.genre').hasClass('HAUT')) {
                labelTaille.html('Haut' + C_ARROW)
            }
            if ($(this).parents('.genre').hasClass('BAS')) {
                labelTaille.html('Bas' + C_ARROW)
            }
            if ($(this).parents('.genre').hasClass('CHAUSSURE')) {
                labelTaille.html('Chaussures' + C_ARROW)
            }
        } else if (options.length > 0 && options.length < 3) {
            // Si on a moins de 3 options sélectionnées
            let selected = ''
            options.each(function () {
                selected += $(this).data('label') + ', '
            })
            labelTaille.html(selected.substr(0, selected.length - 2) + C_ARROW)
        } else {
            // Si on a plus de 3 options sélectionnées
            labelTaille.html(options.length + ' ' + $t('TAILLES') + C_ARROW)
        }

        $(event.currentTarget).removeClass(C_CLASS_PINK_BUTTON)
        tooltips.hideToolTip(event.currentTarget)

        getDataAndSaveProfileV2(this, parentUL)
    })

    $('.bloclestailles .checkbox-t3m').on('click', function (event) {
        let isMobile = false // initiate as false
        // device detection
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
                navigator.userAgent
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                navigator.userAgent.substr(0, 4)
            )
        ) {
            isMobile = true
        }
        const parentUL = $(this).parents('.multiselect-tailles3m')
        const labelTaille = parentUL.parent().siblings('.j_tailles3m')
        const options = parentUL.find('.checkbox-t3m:checked')
        if (options.length === 0) {
            // Si on a rien de sélectionné
            if ($(this).parents('.genre').hasClass('HAUT')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    labelTaille.html(
                        $t('TAILLES_DE') + ' ' + $t('HAUT') + C_ARROW2ROTATE
                    )
                } else {
                    labelTaille.html($t('HAUT') + C_ARROW2ROTATE)
                }
            }
            if ($(this).parents('.genre').hasClass('BAS')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    labelTaille.html(
                        $t('TAILLES_DE') + ' ' + $t('BAS') + C_ARROW2ROTATE
                    )
                } else {
                    labelTaille.html($t('BAS') + C_ARROW2ROTATE)
                }
            }
            if ($(this).parents('.genre').hasClass('AGE')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    labelTaille.html($t('AGE') + C_ARROW2ROTATE)
                } else {
                    labelTaille.html($t('AGES') + C_ARROW2ROTATE)
                }
            }
            if ($(this).parents('.genre').hasClass('CHAUSSURE')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    labelTaille.html($t('POINTURES') + C_ARROW2ROTATE)
                } else {
                    labelTaille.html($t('CHAUSSURES') + C_ARROW2ROTATE)
                }
            }
            if ($(this).parents('.genre').hasClass('CHAUSSURES')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    labelTaille.html($t('POINTURES') + C_ARROW2ROTATE)
                } else {
                    labelTaille.html($t('CHAUSSURES') + C_ARROW2ROTATE)
                }
            }
        } else if (options.length > 0 && options.length < 3) {
            // Si on a moins de 3 options sélectionnées
            let mongenre = ''
            if ($(this).parents('.genre').hasClass('HAUT')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    mongenre = $t('TAILLES_DE') + ' ' + $t('HAUT')
                } else {
                    mongenre = $t('HAUT')
                }
            }
            if ($(this).parents('.genre').hasClass('BAS')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    mongenre = $t('TAILLES_DE') + ' ' + $t('BAS')
                } else {
                    mongenre = $t('BAS')
                }
            }
            if ($(this).parents('.genre').hasClass('AGE')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    mongenre = $t('AGE') + ' ' + $t('BAS')
                } else {
                    mongenre = $t('AGE')
                }
            }
            if ($(this).parents('.genre').hasClass('CHAUSSURE')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    mongenre = $t('POINTURES')
                } else {
                    mongenre = $t('CHAUSSURES')
                }
            }
            if ($(this).parents('.genre').hasClass('CHAUSSURES')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    mongenre = $t('POINTURES')
                } else {
                    mongenre = $t('CHAUSSURES')
                }
            }
            let selected = ''
            options.each(function () {
                selected += $(this).data('label') + ', '
            })
            labelTaille.html(
                mongenre +
                ' (' +
                selected.substr(0, selected.length - 2) +
                ')' +
                C_ARROW2ROTATE
            )
        } else {
            let mongenre = ''

            // Si on a plus de 3 options sélectionnées
            if ($(this).parents('.genre').hasClass('HAUT')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    mongenre = $t('TAILLES_DE') + ' ' + $t('HAUT')
                } else {
                    mongenre = $t('HAUT')
                }
            }
            if ($(this).parents('.genre').hasClass('BAS')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    mongenre = $t('TAILLES_DE') + ' ' + $t('BAS')
                } else {
                    mongenre = $t('BAS')
                }
            }
            if ($(this).parents('.genre').hasClass('AGE')) {
                mongenre = $t('AGE')
            }
            if ($(this).parents('.genre').hasClass('CHAUSSURE')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    mongenre = $t('POINTURES')
                } else {
                    mongenre = $t('CHAUSSURES')
                }
            }
            if ($(this).parents('.genre').hasClass('CHAUSSURES')) {
                if (
                    isMobile &&
                    $(this).parents('.catalogue3m').hasClass('cat3m')
                ) {
                    mongenre = $t('POINTURES')
                } else {
                    mongenre = $t('CHAUSSURES')
                }
            }
            labelTaille.html(
                mongenre +
                ' (' +
                options.length +
                ' ' +
                $t('TAILLES') +
                ')' +
                C_ARROW2ROTATE
            )
        }

        $(event.currentTarget).removeClass(C_CLASS_PINK_BUTTON)
        tooltips.hideToolTip(event.currentTarget)

        getDataAndSaveProfileV2(this, parentUL)
    })
}

/*
 * Switch pour rediriger vers la bonne page du genre selon le type de 3MPlus
 */
function switch3MPlus(event) {
    const $form = $(J_PANEL_ITEM + ':not(.hidden)').find('form')
    const type = $($form).data(J_TYPE_MODULE_DATA)
    let location = ''
    let gender

    if (type === 'simple3MPlus') {
        gender = $($form).data(J_PROFILE_GENDER_DATA)
        if (gender === 'HOMME') {
            location = $(event.currentTarget).data(J_LINKHOMME_DATA)
        }
        if (gender === 'FEMME') {
            location = $(event.currentTarget).data(J_LINKFEMME_DATA)
        }
        if (gender === 'FILLE') {
            location = $(event.currentTarget).data(J_LINKFILLE_DATA)
        }
        if (gender === 'GARCON') {
            location = $(event.currentTarget).data(J_LINKGARCON_DATA)
        }
    } else if (type === 'avance3MPlus') {
        gender = $(event.currentTarget)
            .closest('form')
            .data(J_PROFILE_GENDER_DATA)
        location = $(event.currentTarget).data(J_LINK_DATA)
    }
    redirectToNewGengerProfilePage(gender, location) // Fonction qui va rediriger vers le genre
}

/*
 * Efface l'événements on click sur les boutons
 */
function blockGoButton($element) {
    $element.off('click', setEnableEvent)
    $element.on('click', setDisableEvent)
}

function getDataAndSaveProfileV2(element, parent) {
    const $form = $(element).closest('form') // On récupère le plus proche formulaire
    const data = []
    const selectedDataFamily = $(parent).data(J_FAMILY_DATA)
    const category = $($form).data(J_PROFILE_GENDER_DATA)
    let mustReload = false

    // On va construire le tableau de données. On se sert du form courrant pour cela, afin d'être sur que ce sont bien les bonnes données qui sont envoyées
    $form.find('ul.multiselect-tailles3m').each(function (index, item) {
        const option = $($(item).find('.checkbox-t3m:checked'))
        if (option.length > 0) {
            const dataFamily = $(item).data(J_FAMILY_DATA)
            const values = []
            option.each(function () {
                values.push(this.value)
            })

            data[dataFamily] = values
        } else {
            data[$(item).data(J_FAMILY_DATA)] = []
        }
    })
    let name = profileCookie.existProfilByGender(category)

    if (name === undefined) {
        // Si le profil existe pas, on construit son nom
        name = category + ' ' + (profileCookie.getMaxNbOfProfile() + 1)
    }

    profileCookie.saveDataAsCookie(category, name, data, selectedDataFamily)

    checkIfGoButtonIsAvailableAndShow($form)

    // On récupère la variable indiquant si on reload la page ou non
    mustReload = $(J_PANEL_ITEM).data(J_MUST_LOAD_DATA)
    if (mustReload !== undefined && mustReload === true) {
        if ($(J_URL).length > 0) {
            if ($(J_URL).val().indexOf('/Catalogue') !== -1) {
                window.location.href = url.deleteParams(
                    'ct',
                    window.location.href
                ) // GCVIA fix Mantis 0001952
            }
        }
    }
}

/*
 * Redirige vers la page du genre passé en paramètre
 */
function redirectToNewGengerProfilePage(gender, location) {
    const profile = profileCookie.getProfileByGender(gender)
    switch (gender) {
        case 'FEMME':
        case 'HOMME':
            if (profile !== undefined) {
                if (profile.sizes !== undefined) {
                    if (
                        profile.sizes.BAS !== undefined &&
                        profile.sizes.BAS.length > 0 &&
                        profile.sizes.HAUT !== undefined &&
                        profile.sizes.HAUT.length > 0 &&
                        profile.sizes.CHAUSSURE !== undefined &&
                        profile.sizes.CHAUSSURE.length > 0
                    ) {
                        document.location.href = location
                    }
                }
            }
            break
        case 'FILLE':
        case 'GARCON':
            if (profile !== undefined) {
                if (profile.sizes !== undefined) {
                    if (
                        profile.sizes.AGE !== undefined &&
                        profile.sizes.AGE.length > 0 &&
                        profile.sizes.CHAUSSURE !== undefined &&
                        profile.sizes.CHAUSSURE.length > 0
                    ) {
                        document.location.href = location
                    }
                }
            }
            break
        default:
            document.location.href = location
    }
}

/*
 * Va récupérer le form et vérifier pour vérifier si on doit afficher le bouton cliquable ou non
 */
function checkButtonForEachForm() {
    const selectedGender = $(J_BORDER_SELECTED + C_ACTIVE_SELECTOR)
        .find(J_LIST_CATEGORY)
        .data(J_GENDER_DATA)

    const form = $(
        J_FORM_3MPLUS +
        '[data-' +
        J_PROFILE_GENDER_DATA +
        "='" +
        selectedGender +
        "']"
    )
    checkIfGoButtonIsAvailableAndShow(form)
}

/*
 * Fonction appelé sur le click du bouton go grisé.
 * Si le bouton est grisé, on appel cette méthode qui va afficher les tooltips
 */
function setOnClickToolTip(event) {
    let form = $(J_PANEL_ITEM + ':not(.hidden)').find('form')
    const type = $(form).data(J_TYPE_MODULE_DATA)
    let gender = ''
    let location = 'right'

    if (type === 'simple3MPlus') {
        gender = $(form).data(J_PROFILE_GENDER_DATA)
        location = 'bottom'
    } else if (type === 'avance3MPlus') {
        gender = $(event.currentTarget)
            .closest('form')
            .data(J_PROFILE_GENDER_DATA)
        form = $(event.currentTarget).closest('form')
    }

    $(form)
        .find('ul.multiselect-tailles3m')
        .each(function (index, item) {
            const option = $($(item).find('.checkbox-t3m:checked'))
            if (option.length == 0) {
                const dataFamily = $(item).data(J_FAMILY_DATA)
                const div = $(item).closest('.j_' + gender + '_' + dataFamily)
                const button = $(div).find('.btn-multiselect') // On récupère le button le plus proche : Dans le cas du simple et avancé, on a pas de form
                button.addClass(C_CLASS_PINK_BUTTON)
                tooltips.setEventOnItem(
                    button,
                    location,
                    $t('VEUILLEZ_SELECTIONNER_TAILLES')
                )
            }
        })
}
$('.j_submit3MPlusDropDown').on('click', function () {
    window.location.href = url.deleteParams('np', window.location.href)
})
/*
 * Va checker si il y a des counts, et s'ils sont à 0. Si c'est le cas on met en place les tooltips
 */
function setToolTip() {
    const $triggers = $(J_TOOLTIP_TRIGGER)
    let dataCount = -1

    if ($triggers.length > 0) {
        $triggers.each(function (index, item) {
            dataCount = $(item).data(J_TRIGGER_DATA)

            if (dataCount === 0) {
                // On regarde si on a bien 0
                const dataFamily = $(item).data(J_FAMILY_DATA)
                const form = $(
                    'ul.multiselect-tailles3m' +
                    '[data-' +
                    J_FAMILY_DATA +
                    "='" +
                    dataFamily +
                    "']"
                ).closest('form') // On récupère le form correspondant à la nature (haut, bas, etc.)
                if (form.length > 0) {
                    const button = $(form).find('button') // et grace au form, on récupère le bouton
                    button.addClass(C_CLASS_PINK_BUTTON)
                    tooltips.setEventOnItem(
                        button,
                        'right',
                        $t('VEUILLEZ_SELECTIONNER_TAILLES')
                    )
                }
            }
        })
    }
}

/*
 * Prend le form courant en paramètre. Va vérifier si les multiselects de ce form ont des valeurs sélectionnées
 * Si oui, on va afficher le bouton cliquable et setter le click dessus
 * Si non, on va afficher le bouton non cliquable et supprimer l'event click dessus
 */
function checkIfGoButtonIsAvailableAndShow(form) {
    const button = $(J_BUTTON_SUBMIT)
    const classForShowing = C_BUTTON_STYLE_ON
    const classForHidding = C_BUTTON_STYLE_OFF
    let result = false

    // pour chaque multiselect, on va vérifier si on a des options sélectionnées. Si oui, on affiche le bouton cliquable
    // Si non, on affiche le non cliquable et on sort de la boucle
    $(form)
        .find('ul.multiselect-tailles3m')
        .each(function (index, item) {
            const option = $($(item).find('.checkbox-t3m:checked'))
            if (option.length > 0) {
                $(button).addClass(classForShowing)
                $(button).removeClass(classForHidding)
                result = true
            } else {
                blockGoButton($(button))
                $(button).removeClass(classForShowing)
                $(button).addClass(classForHidding)
                result = false
                return false
            }
        })
    if (result === true) {
        setOnClickEvent($(button)) // Si on arrive là, c'est qu'on  a des tailles dans les trois champs. Donc on peut setter le click sur le bouton
    }
}

export default {
    process: process,
    processLight: processLight
}
